import {IntermediatePart} from "../../intermediatePart";

export default class ShowerCurb extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_curb';
    this.partName = 'Shower Curb';
    this.translateId = "visualizer.bathroom.shower.shower_curb";
    this.canBeDisabled = false;
    this.isStoneFeature = true;
  }

  hideLayerCondition() {
    const shower = this.getParent();
    if (shower?.layout?.type === 10) {
      return false
    }
    return !shower.showerFloorIsActive || shower.showerTubComboIsActive()
  }

  getArrayOfConditions() {
    const showerParent = this.getParent();
    let conditions = super.getArrayOfConditions(); //roomLayout
    const showerSize = showerParent.showerSize();
    if (showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      })
    }
    return conditions
  }

}
